/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './daysRemainingCircle.tpl.html';
import './header.tpl.html';

/**
 * Module for the mobile header view.
 */
angular
  .module('mobile.header', [])
  .controller(
    'MobileHeaderCtrl',
    function (
      $scope,
      $state,
      $filter,
      $rootScope,
      $timeout,
      $uibModal,
      billingUtils,
      bodyUtils,
      MOBILE_STATES,
      MOBILE_EVENTS,
      DELAYS,
      authFactory
    ) {
      // default to 100% for the days remaining indicator.
      $scope.daysRemainingPct = 100;
      // value used to indicate that the standard header is not shown.
      $scope.altView = false;
      $scope.isMaintenanceMode = $rootScope.maintenanceModeFlag;

      // used to hide some elements in chatter
      authFactory.displayedInChatter().then(function (displayedInChatter) {
        $scope.isChatter = displayedInChatter;
      });

      // Load the billing info in order to find teh correct days remaining in subscription and trial status.
      billingUtils.getPaymentInfo().then(function (paymentInfo) {
        var daysRemaining = moment(paymentInfo.expires).diff(moment(new Date()), 'days'),
          totalDays = moment(paymentInfo.expires).diff(moment(paymentInfo.starts), 'days'),
          remainingPct = parseInt((daysRemaining / totalDays) * 100, 10);
        $scope.inTrial = billingUtils.inTrial();
        $scope.isExpired = billingUtils.isAccessStopped();

        // Add a delay to updating the days remaining value so that he animation will show up.
        $timeout(function () {
          $scope.daysRemainingPct = remainingPct >= 0 ? remainingPct : 0;
        }, DELAYS.SHOW_TRIAL_CIRCLE);
      });

      /**
       * Function to launch the support modal.
       */
      $scope.openSupportModal = function () {
        // make sure the body is large enough to hold the support dialog
        $uibModal
          .open({
            templateUrl: 'shared/modal/supportModal.tpl.html',
            controller: 'HelpModalCtrl',
            windowClass: 'sbsf-support-modal-window',
            scope: $scope
          })
          .result.then(
            function () {
              // case where modal is resolved
              bodyUtils.setBodyStyle(undefined);
            },
            function () {
              // case where modal is rejected
              bodyUtils.setBodyStyle(undefined);
            }
          );
      };

      /**
       * Function to launch the support modal.
       */
      $scope.openSupportModal = function () {
        // make sure the body is large enough to hold the support dialog
        $uibModal
          .open({
            templateUrl: 'shared/modal/supportModal.tpl.html',
            controller: 'HelpModalCtrl',
            windowClass: 'sbsf-support-modal-window',
            scope: $scope
          })
          .result.then(
            function () {
              // case where modal is resolved
              bodyUtils.setBodyStyle(undefined);
            },
            function () {
              // case where modal is rejected
              bodyUtils.setBodyStyle(undefined);
            }
          );
      };

      /**
       * Utility to determine if the menu is the current state.
       *
       * @returns {boolean} - True if the current state is the menu.
       */
      $scope.showingMenu = function () {
        return $state.current.name === MOBILE_STATES.menu.state;
      };

      /**
       * Function called when the event to show the expiration information should be
       * fired.
       */
      $scope.showExpiresMsg = function () {
        if ($scope.inTrial) {
          billingUtils.getPaymentInfo().then(function (paymentInfo) {
            var type = $filter('i18n')($scope.inTrial ? 'TRIAL' : 'SUBSCRIPTION'),
              numDaysRemaining = moment(paymentInfo.expires).diff(moment(), 'days');
            numDaysRemaining = numDaysRemaining >= 0 ? numDaysRemaining : 0;

            $rootScope.$emit(MOBILE_EVENTS.SHOW_MOBILE_ALERT, {
              msg: $filter('i18n')('NUM_DAYS_REMAINING', [numDaysRemaining, type]),
              sub: $filter('i18n')('EXPIRES_PARENS', moment(paymentInfo.expires).format(SBSF.messages.MDY))
            });
          });
        }
      };

      /**
       * Returns the text to be displayed in the header.
       *
       * @returns {String} - The string to be displayed.
       */
      $scope.getHeaderText = function () {
        var stringKey;
        _.each(MOBILE_STATES, function (value, key) {
          if (value.state === $state.current.name && key !== 'menu') {
            stringKey = key.toUpperCase();
          }
        });
        $scope.headerText = stringKey ? $filter('i18n')(stringKey) : $scope.headerText;

        return $scope.headerText;
      };

      $scope.toggleAsideMenu = function () {
        $rootScope.isAsideMenuOpen = !$rootScope.isAsideMenuOpen;
      };

      /**
       * Used to indicate if the days left indicator should be shown.
       * @return {boolean} - true if indicator should be shown.
       */
      $scope.showDaysLeft = function () {
        var current = $state.current.name,
          showIt;
        // only show if in trial...
        if (!$scope.inTrial || $scope.isExpired) {
          showIt = false;
        } else {
          // ... and only show indicator if currently on dashboard, or in menu with dashboard as previous view.
          showIt = current === MOBILE_STATES.dashboard.state || MOBILE_STATES.activity.state;
        }
        return showIt;
      };

      /**
       * Determines if the refresh header button should be shown.
       *
       * @returns {boolean} - true to show the refresh icon.
       */
      $scope.showRefresh = function () {
        return $state.current.name === MOBILE_STATES.activity.state && !$scope.isExpired;
      };

      /**
       * Handler for the refresh button. It will fire MOBILE_EVENTS.HEADER_REFRESH
       * $rootScope event when called.
       */
      $scope.refreshHandler = function () {
        $rootScope.$emit(MOBILE_EVENTS.HEADER_REFRESH);
      };

      /**
       * Handler for the alternate view back arrow.
       */
      $scope.altBackHandler = function () {
        $scope.altView = false;
        $state.go($scope.altPreviousState);
      };

      /**
       * Add an event listener for the HEADER_CHANGE event indicating that the alternate
       * back view should be shown.
       */
      $rootScope.$on(MOBILE_EVENTS.HEADER_CHANGE, function (evt, altObj) {
        $scope.altView = true;
        // Do not care about previous state in chatter mode.
        if (!$scope.isChatter) {
          $scope.altPreviousState = altObj.previous;
        }
        $scope.altTitle = altObj.title || '';
      });

      // Watch the $rootScope.maintenanceModeFlag to hide/show drop down.
      $scope.$watch(
        function () {
          return $rootScope.maintenanceModeFlag;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.isMaintenanceMode = $rootScope.maintenanceModeFlag;
          }
        }
      );
    }
  )
  /**
   * The directive for the circle chart used to indicate trial days remaining.
   * Based off information found at:
   * https://medium.com/@andsens/radial-progress-indicator-using-css-a917b80c43f9
   */
  .directive('daysRemainingCircle', function () {
    return {
      templateUrl: 'mobile/header/daysRemainingCircle.tpl.html',
      scope: {
        pct: '=daysRemainingPct'
      }
    };
  });
